import React, { forwardRef, useId } from "react";
import * as RadixSelect from "@radix-ui/react-select";
import { ChevronDown, Check, ChevronUp } from "lucide-react";
import "./Select.css";

export function Select({
  label,
  hint,
  error,
  placeholder = "Selecciona...",
  value,
  defaultValue,
  onValueChange,
  options = [],
  fullWidth = true,
  disabled = false,
  id: idProp,
  className = "",
  children,
}) {
  const reactId = useId();
  const id = idProp || reactId;
  return (
    <div className={`ui-field ${fullWidth ? "ui-field-full" : ""} ${error ? "ui-field-error" : ""} ${className}`}>
      {label && (
        <label htmlFor={id} className="ui-field-label">
          {label}
        </label>
      )}
      <RadixSelect.Root
        value={value}
        defaultValue={defaultValue}
        onValueChange={onValueChange}
        disabled={disabled}
      >
        <RadixSelect.Trigger id={id} className="ui-select-trigger">
          <RadixSelect.Value placeholder={placeholder} />
          <RadixSelect.Icon className="ui-select-icon">
            <ChevronDown size={16} />
          </RadixSelect.Icon>
        </RadixSelect.Trigger>
        <RadixSelect.Portal>
          <RadixSelect.Content className="ui-select-content" position="popper" sideOffset={6}>
            <RadixSelect.ScrollUpButton className="ui-select-scroll">
              <ChevronUp size={14} />
            </RadixSelect.ScrollUpButton>
            <RadixSelect.Viewport className="ui-select-viewport">
              {children ||
                options.map((opt) => (
                  <SelectItem key={opt.value} value={String(opt.value)} disabled={opt.disabled}>
                    {opt.label}
                  </SelectItem>
                ))}
            </RadixSelect.Viewport>
            <RadixSelect.ScrollDownButton className="ui-select-scroll">
              <ChevronDown size={14} />
            </RadixSelect.ScrollDownButton>
          </RadixSelect.Content>
        </RadixSelect.Portal>
      </RadixSelect.Root>
      {(error || hint) && (
        <span className={`ui-field-help ${error ? "ui-field-help-error" : ""}`}>
          {error || hint}
        </span>
      )}
    </div>
  );
}

export const SelectItem = forwardRef(function SelectItem(
  { children, className = "", ...props },
  ref
) {
  return (
    <RadixSelect.Item ref={ref} className={`ui-select-item ${className}`} {...props}>
      <RadixSelect.ItemText>{children}</RadixSelect.ItemText>
      <RadixSelect.ItemIndicator className="ui-select-indicator">
        <Check size={14} />
      </RadixSelect.ItemIndicator>
    </RadixSelect.Item>
  );
});

export const SelectSeparator = () => <RadixSelect.Separator className="ui-select-separator" />;
export const SelectGroup = RadixSelect.Group;
export const SelectLabel = ({ children, className = "" }) => (
  <RadixSelect.Label className={`ui-select-group-label ${className}`}>{children}</RadixSelect.Label>
);
